jQuery(function() {
    if( jQuery(".wpb-date").length ){
        jQuery(".wpb-date").datetimepicker({
            controlType: 'select',
            oneLine: true,
            timeFormat: 'hh:mm tt'
        });
    }
});